import { graphql } from "@/gql"

// The staff directory (@auger/core directory.ts), loaded once on boot: the
// person records of the staff list with their avatar and primary email, and
// the partners list's members. The slugs are STAFF_LIST_SLUG and
// PARTNERS_LIST_SLUG.
export const fetchDirectory = graphql(`
  query fetchDirectory {
    directory_staff: record_listings(
      where: { list: { slug: { _eq: "heavybit-employees" }, type: { _eq: "list" } } }
    ) {
      record {
        ...RecordFields
        contacts(
          where: { contact_type: { _eq: "email" } }
          order_by: [{ is_primary: desc }, { created_at: asc }]
          limit: 1
        ) {
          value
        }
      }
    }
    directory_partners: record_listings(
      where: { list: { slug: { _eq: "heavybit-partners" }, type: { _eq: "list" } } }
    ) {
      record_id
    }
  }
`)

// People who are not on the staff list but are still named somewhere (a
// former owner, assignee or actor), loaded in one batch by the users store.
export const fetchPeopleByIds = graphql(`
  query fetchPeopleByIds($ids: [Int!]!) {
    people: records(where: { id: { _in: $ids }, type: { _eq: "person" } }) {
      ...RecordFields
    }
  }
`)

// The signed-in person (x-hasura-person-id), at boot: their name, primary
// email, avatar and children, for the user store and the settings page.
export const fetchSelf = graphql(`
  query fetchSelf($personId: Int!) {
    person: records_by_pk(id: $personId) {
      ...RecordFields
      contacts(
        where: { contact_type: { _eq: "email" } }
        order_by: [{ is_primary: desc }, { created_at: asc }]
        limit: 1
      ) {
        value
      }
      children {
        ...RecordFields
      }
    }
  }
`)
